
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css"; // require swiper css
Vue.use(VueAwesomeSwiper /* { default global options } */);


